import ShowHideTable from "./component";

export default ShowHideTable;